// FULLSCREEN
// -----------------------------------
import $ from 'jquery';
import screenfull from 'screenfull';

function initScreenfull() {
    if (typeof screenfull === 'undefined') return;

    const $doc = $(document);
    const $fsToggler = $(this);

    // Not supported under IE
    const ua = window.navigator.userAgent;

    // eslint-disable-next-line
    if (ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./)) {
        $fsToggler.addClass('hide');
    }

    if (
        !$fsToggler.is(':visible') // hidden on mobiles or IE
    )
        return;

    $fsToggler.on('click', function(e) {
        e.preventDefault();

        if (screenfull.enabled) {
            screenfull.toggle();

            // Switch icon indicator
            toggleFSIcon($fsToggler);
        } else {
            console.log('Fullscreen not enabled');
        }
    });

    if (screenfull.raw && screenfull.raw.fullscreenchange)
        $doc.on(screenfull.raw.fullscreenchange, function() {
            toggleFSIcon($fsToggler);
        });

    function toggleFSIcon($element) {
        if (screenfull.isFullscreen)
            $element
                .children('em')
                .removeClass('fa-expand')
                .addClass('fa-compress');
        else
            $element
                .children('em')
                .removeClass('fa-compress')
                .addClass('fa-expand');
    }
}

export default () => {
    $('[data-toggle-fullscreen]').each(initScreenfull);
};



// WEBPACK FOOTER //
// ./src/components/angle/common/fullscreen.js